import React, { useEffect, useState } from 'react';

const BackgroundGlow: React.FC = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [glowElements, setGlowElements] = useState<{ id: number; x: number; y: number; size: number; color: string }[]>([]);
  
  useEffect(() => {
    // Create multiple glow elements
    const elements = [];
    for (let i = 0; i < 8; i++) {
      elements.push({
        id: i,
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        size: Math.random() * 200 + 300,
        color: i === 0 ? 'rgba(120, 100, 255, 0.12)' : 
               i === 1 ? 'rgba(221, 70, 239, 0.12)' : 
               i === 2 ? 'rgba(66, 137, 255, 0.12)' :
               i === 3 ? 'rgba(150, 80, 220, 0.12)' :
               i === 4 ? 'rgba(100, 180, 255, 0.12)' :
               i === 5 ? 'rgba(255, 100, 180, 0.12)' :
               i === 6 ? 'rgba(70, 180, 220, 0.12)' :
                         'rgba(180, 120, 255, 0.12)'
      });
    }
    setGlowElements(elements);
    
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({
        x: e.clientX,
        y: e.clientY
      });
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  
  return (
    <>
      <div 
        className="glow-effect cursor-glow" 
        style={{ 
          left: `${position.x - 150}px`, 
          top: `${position.y - 150}px`,
          transition: 'all 0.8s cubic-bezier(0.1, 0.9, 0.2, 1)'
        }}
      ></div>
      
      {glowElements.map(elem => (
        <div
          key={elem.id}
          className="fixed pointer-events-none"
          style={{
            width: `${elem.size}px`,
            height: `${elem.size}px`,
            left: `${elem.x}px`,
            top: `${elem.y}px`,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${elem.color} 0%, rgba(0, 0, 0, 0) 70%)`,
            opacity: 0.8,
            transform: 'translate(-50%, -50%)',
            animation: `float-glow ${10 + elem.id * 5}s ease-in-out infinite alternate`
          }}
        ></div>
      ))}
    </>
  );
};

export default BackgroundGlow;
